import React, { useState, useRef, useEffect } from 'react';
import { AlyzeLogoSolid } from '@shared/components/icons';
import { HeaderButton, HamburgerIcon } from './components';
import { MobileMenu } from './MobileMenu';

export const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const headerRef = useRef<HTMLElement>(null);
  const menuRef = useRef<HTMLDivElement>(null);

  const handleJoinWaitlist = () => {
    window.location.href = '/alyze-membership-waitlist';
  };

  // Close menu when clicking outside (desktop only)
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      // Only apply in desktop mode (window width >= 768px)
      if (window.innerWidth < 768) return;
      
      if (
        isMenuOpen &&
        headerRef.current &&
        menuRef.current &&
        !headerRef.current.contains(event.target as Node) &&
        !menuRef.current.contains(event.target as Node)
      ) {
        setIsMenuOpen(false);
      }
    };

    if (isMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen]);

  return (
    <>
      <header
        ref={headerRef}
        className="w-full h-[70px] md:h-[67px] fixed top-0 left-0 right-0 z-50"
        style={{ 
          backgroundColor: 'rgba(0, 0, 0, 0.75)',
          backdropFilter: 'blur(10px)',
          WebkitBackdropFilter: 'blur(10px)',
          paddingLeft: '16px',
          paddingRight: '16px',
          boxSizing: 'border-box',
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
        }}
      >
        <div className="flex items-center justify-between w-full h-full">
          {/* Logo */}
          <div className="flex items-center flex-shrink-0">
            <AlyzeLogoSolid className="h-[20px] md:h-[24px] w-auto" color="#F2F2F2" />
          </div>

          {/* Right side actions */}
          <div className="flex items-center flex-shrink-0" style={{ gap: '16px' }}>
            <HeaderButton onClick={handleJoinWaitlist}>
              Join the Waitlist
            </HeaderButton>
            <HamburgerIcon 
              isOpen={isMenuOpen} 
              onClick={() => setIsMenuOpen(!isMenuOpen)} 
            />
          </div>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      <MobileMenu isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} menuRef={menuRef} />
    </>
  );
};
